import React from "react";
import { InputElement, Label, Wrapper } from "./styled";

export const Input = ({type, label, placeholder, required,
                        value = '', onChange, error, ...props}) =>
    <Wrapper>
        {label && <Label required={required}>{label}</Label> }
        <InputElement
            {...props}
            placeholder={placeholder}
            type={type}
            required={required}
            value={value}
            onChange={e => {
                if (!onChange) {
                    return;
                }
                onChange(e.target.value);
            }}
            data-error={Boolean(error)}
        />
    </Wrapper>;

export default Input;
